import pathfinder from '@fiverr-private/pathfinder';
import { PAGE_NAME } from '../../../../configuration/constants';

// export const menuItemsByStatus: Record<Gql.DmBriefStatus, (MoreItem | MoreDividerItem)[]> = {
// ACTIVE: [
//     {
//         type: 'action',
//         labelKey: 'actions.mark_as_complete',
//         action: () => null,
//     },
//     {
//         type: 'divider',
//     },
//     {
//         type: 'action',
//         labelKey: 'actions.rename',
//         action: () => null,
//     },
//     {
//         type: 'action',
//         labelKey: 'actions.copy_link',
//         action: () => null,
//     },
//     {
//         type: 'divider',
//     },
//     {
//         type: 'action',
//         labelKey: 'actions.delete_brief',
//         action: () => null,
//     },
// ],
// CLOSED_BY_BUYER: [
//     {
//         type: 'action',
//         labelKey: 'actions.reuse',
//         action: () => null,
//     },
//     {
//         type: 'action',
//         labelKey: 'actions.delete_brief',
//         action: () => null,
//     },
// ],
// CLOSED_STALE: [
//     {
//         type: 'action',
//         labelKey: 'actions.open_brief_to_offers',
//         action: () => null,
//     },
//     {
//         type: 'divider',
//     },
//     {
//         type: 'action',
//         labelKey: 'actions.rename',
//         action: () => null,
//     },
//     {
//         type: 'action',
//         labelKey: 'actions.reuse',
//         action: () => null,
//     },
//     {
//         type: 'divider',
//     },
//     {
//         type: 'action',
//         labelKey: 'actions.delete_brief',
//         action: () => null,
//     },
// ],
// PENDING_MODERATION: [
//     {
//         type: 'action',
//         labelKey: 'actions.reuse',
//         action: () => null,
//     },
// ],
// CLOSED_FAILED_MODERATION: [
//     {
//         type: 'action',
//         labelKey: 'actions.reuse',
//         action: () => null,
//     },
// ],
// CLOSED_BUYER_BLOCKED: [
//     {
//         type: 'action',
//         labelKey: 'actions.reuse',
//         action: () => null,
//     },
// ],
// CLOSED_BUYER_RESTRICTED: [
//     {
//         type: 'action',
//         labelKey: 'actions.reuse',
//         action: () => null,
//     },
// ],
// };

export const getManagementPageUrl = (briefId: string, tab?: string) =>
    pathfinder(
        'dynamic_matching_management_page',
        { briefId, tab: tab || 'undefined' },
        { query: { source: PAGE_NAME } }
    );

export const BRIEFS_LIST_QUERY_KEY = ['briefs-list'];
export const BRIEFS_PAGINATED_LIST_QUERY_KEY = ['paginated-briefs-list'];
